import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  status: 'initial',
  weeks: {},
  fetch: {
    status: 'initial'
  },
  create: {
    status: 'initial'
  },
  edit: {
    status: 'initial'
  },
  delete: {
    status: 'initial'
  }
}

const Booking = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Booking;



// WEBPACK FOOTER //
// ./src/store/modules/booking/store.js